import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';

// external-global styles must be imported in your JS.
import normalizeCss from 'normalize.css';
import s from './Layout.css';
import Header from '../Header';
import Feedback from '../Feedback';
import Footer from '../Footer';
import WhatsAppFloatingButton from '../WhatsAppFloatingButton/WhatsAppFloatingButton';
import history from '../../history';

class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
        
    return (
      <div>
        <Header  location={history?.location?.pathname}/>
        {this.props.children}
        <WhatsAppFloatingButton />
        {/* <Feedback />*/}
        <Footer /> 
      </div>
    );
  }
}

export default withStyles(normalizeCss, s)(Layout);
